import fire from "../fire";
export default {
    // data(){
    //     msg: "Hola"
    // },
    // created: function () {
    //     console.log('Printing from the Mixin');
    // },
    // methods: {
    //     displayMessage: function () {
    //         console.log('Now printing from a mixin function');
    //     }
    // }
}
